import { useRef } from "react";
import { interviews } from "../../assets/text/interview";

const MobileInterviewLink = ({ toggle, handleImageLink, content }) => {
  const divRef = useRef(null);

  return (
    <div className="mobile-interview-link">
      <div id="dummy" ref={divRef} style={{ position: "absolute", top: "0" }} />
      {!toggle ? (
        <div className="mobile-interview-link-arabic">
          <div className="mobile-interview-link-arabic-image">
            <img
              alt="interview-link"
              src={`images/${content.image}`}
              className="mobile-interview-link-arabic-image-img"
            ></img>
          </div>
          <div className="mobile-interview-link-arabic-name">
            {content.content.arabic.title}
          </div>
          <div className="mobile-interview-link-arabic-date">
            {content.content.arabic.date} &nbsp;/ &nbsp;
            <span className="mobile-interview-link-arabic-date-share">
              {" "}
              نشـــــر
            </span>
          </div>
          <div className="mobile-interview-link-arabic-description">
            {content.content.arabic.text.map((text, textIndex) => {
              const parts = text.split(/\*\*/g);
              const marginTop =
                textIndex !== 0 &&
                text.slice(0, 2) === "**" &&
                text.slice(text.length - 2) === "**"
                  ? "5%"
                  : "1.3%";
              const marginBottom =
                textIndex === content.content.arabic.text.length - 1
                  ? "5%"
                  : "0%";
              return (
                <div
                  style={{ marginTop: marginTop, marginBottom: marginBottom }}
                >
                  {parts.map((part, partIndex) => {
                    part = part.split(/\$\$/g);
                    let newPart = part.map((subpart, subpartIndex) => {
                      if (subpartIndex % 3 === 0) {
                        return <span key={subpartIndex}>{subpart}</span>;
                      } else if (subpartIndex % 3 === 1) {
                        return (
                          <span>
                            <span key={subpartIndex}>{subpart}</span>
                            <img
                              alt={subpartIndex}
                              style={{
                                height: "100%",
                                width: "100%",
                                objectFit: "cover",
                                padding: "5% 1.3%",
                              }}
                              src={`images/${part[subpartIndex + 1]}`}
                            ></img>
                          </span>
                        );
                      }
                    });

                    if (partIndex % 2 === 0) {
                      return (
                        <span
                          className="mobile-interview-link-arabic-description-answer"
                          key={partIndex}
                        >
                          {newPart}
                        </span>
                      );
                    } else {
                      return (
                        <span
                          className="mobile-interview-link-arabic-description-question"
                          key={partIndex}
                        >
                          {newPart}
                        </span>
                      );
                    }
                  })}
                </div>
              );
            })}
          </div>

          <div className="mobile-interview-link-arabic-articles">
            {interviews.map((article, index) => (
              <>
                {index === 0 && (
                  <span className="mobile-interview-link-arabic-articles-more">
                    للمزيد{" "}
                  </span>
                )}
                <div
                  key={article.date}
                  className="mobile-interview-link-arabic-articles-article"
                  style={{
                    borderTop: index === 0 && "0",
                  }}
                >
                  <div className="mobile-interview-link-arabic-articles-article-text">
                    <div
                      className="mobile-interview-link-arabic-articles-article-text-title"
                      onClick={() => {
                        handleImageLink(true, article);
                      }}
                    >
                      {article.content.arabic.title}
                    </div>
                    <div className="mobile-interview-link-arabic-articles-article-text-date">
                      {article.content.arabic.date}
                    </div>
                  </div>
                  <div style={{ width: "45%" }}>
                    <img
                      className="mobile-interview-link-arabic-articles-article-image"
                      src={`images/${article.imageSquare}`}
                      alt="thumbnail"
                    ></img>
                  </div>
                </div>
              </>
            ))}
          </div>
        </div>
      ) : (
        <div className="mobile-interview-link-english">
          <div className="mobile-interview-link-english-image">
            <img
              alt="interview-link"
              src={`images/${content.image}`}
              className="mobile-interview-link-english-image-img"
            ></img>
          </div>
          <div className="mobile-interview-link-english-name">
            {content.content.english.title}
          </div>
          <div className="mobile-interview-link-english-date">
            {`${content.content.english.date} / share`}{" "}
          </div>
          <div className="mobile-interview-link-english-description">
            {content.content.english.text.map((text, textIndex) => {
              const parts = text.split(/\*\*/g);
              const marginTop =
                textIndex !== 0 &&
                text.slice(0, 2) === "**" &&
                text.slice(text.length - 2) === "**"
                  ? "5%"
                  : "1.3%";
              const marginBottom =
                textIndex === content.content.english.text.length - 1
                  ? "5%"
                  : "0%";
              return (
                <div
                  style={{ marginTop: marginTop, marginBottom: marginBottom }}
                >
                  {parts.map((part, partIndex) => {
                    part = part.split(/\$\$/g);
                    let newPart = part.map((subpart, subpartIndex) => {
                      if (subpartIndex % 3 === 0) {
                        return <span key={subpartIndex}>{subpart}</span>;
                      } else if (subpartIndex % 3 === 1) {
                        return (
                          <span>
                            <span key={subpartIndex}>{subpart}</span>
                            <img
                              alt={subpartIndex}
                              style={{
                                height: "100%",
                                width: "100%",
                                objectFit: "cover",
                                padding: "5% 1.3%",
                              }}
                              src={`images/${part[subpartIndex + 1]}`}
                            ></img>
                          </span>
                        );
                      }
                    });

                    if (partIndex % 2 === 0) {
                      return (
                        <span
                          className="mobile-interview-link-english-description-answer"
                          key={partIndex}
                        >
                          {newPart}
                        </span>
                      );
                    } else {
                      return (
                        <span
                          className="mobile-interview-link-english-description-question"
                          key={partIndex}
                        >
                          {newPart}
                        </span>
                      );
                    }
                  })}
                </div>
              );
            })}
          </div>

          <div className="mobile-interview-link-english-articles">
            {interviews.map((article, index) => (
              <>
                {index === 0 && (
                  <span className="mobile-interview-link-english-articles-more">
                    more like this{" "}
                  </span>
                )}
                <div
                  key={article.date}
                  className="mobile-interview-link-english-articles-article"
                  style={{
                    borderTop: index === 0 && "0",
                  }}
                >
                  <div className="mobile-interview-link-english-articles-article-text">
                    <div
                      className="mobile-interview-link-english-articles-article-text-title"
                      onClick={() => {
                        handleImageLink(true, article);
                      }}
                    >
                      {article.content.english.title}
                    </div>
                    <div className="mobile-interview-link-english-articles-article-text-date">
                      {article.content.english.date}
                    </div>
                  </div>
                  <div style={{ width: "45%" }}>
                    <img
                      className="mobile-interview-link-english-articles-article-image"
                      src={`images/${article.imageSquare}`}
                      alt="thumbnail"
                    ></img>
                  </div>
                </div>
              </>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileInterviewLink;
